import { Controller } from "@hotwired/stimulus"

// Shows a full-viewport overlay while a file upload + form submission is in progress.
// Prevents double-taps by covering the entire screen.
// Uses a pre-rendered template (data-upload-overlay-target="template") for the overlay content.
//
// Usage:
//   form data-controller="utilities--upload-overlay auto-submit"
//     input type="file" data-action="change->utilities--upload-overlay#show"
//     template data-utilities--upload-overlay-target="template"
//       ...overlay content...
//
export default class extends Controller {
  static targets = ["template"]

  connect() {
    this.hide = this.hide.bind(this)
    this.element.addEventListener("turbo:submit-end", this.hide)
  }

  show() {
    if (this.overlay) return

    this.overlay = document.createElement("div")
    this.overlay.className = "fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/50"
    this.overlay.innerHTML = this.templateTarget.innerHTML
    document.body.appendChild(this.overlay)
  }

  hide() {
    this.overlay?.remove()
    this.overlay = null
    const input = this.element.querySelector("input[type=file]")
    if (input) { input.disabled = false; input.value = "" }
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.hide)
    this.hide()
  }
}
